module.exports = __webpack_public_path__ + "img/switcher-prev.999e2407.svg";